import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { AttachmentObjectType } from '../../../common/pokCore/validation/enums';
import { SimpleNoteEditor } from '../Attachments/SimpleNoteEditor';
import { PermissionsEnum } from '../../../common/pokCore/authorization/permissions';
import { useAuth } from '../../../common/hooks/useAuth';
import oneliner from '../../../common/oneliner';
import SelectOptionInfo from '../Selects/SelectOptionInfo';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ManyAttachmentLinkProps {
  objectId: string;
  objectType: AttachmentObjectType;
  note: string;
  notes: string;
  refresh: boolean;
  setRefresh: (refresh: boolean) => void;
  additionalText?: string;
  checkFinance?: boolean;
}

export const ManyAttachmentLink: React.FC<ManyAttachmentLinkProps> = props => {
  const NOTE_MAX_LENGTH = 150;
  const { t, tk } = useTranslation('administrationLng');
  const auth = useAuth();
  const [show, setShow] = useState(false);
  const authFinance = auth.check(PermissionsEnum.Finance);

  const handleClick = () => {
    setShow(true);
  };

  const handleClose = () => {
    props.setRefresh(!props.refresh);
    setShow(false);
  };
  return (
    <>
      {(!props.checkFinance || authFinance) && (
        <OverlayTrigger overlay={<Tooltip>{t(tk.attachment.comment)}</Tooltip>}>
          <Button
            className="p-0"
            onClick={e => {
              e.stopPropagation();
              handleClick();
            }}
            variant="btn-info"
          >
            <Icon.PlusCircleFill className="icon-green" />
          </Button>
        </OverlayTrigger>
      )}{' '}
      {props.note && (
        <>
          {oneliner(props.note, NOTE_MAX_LENGTH)}
          <SelectOptionInfo
            label={props.notes}
            title={t(tk.attachment.note)}
            placement="auto"
          />
        </>
      )}
      <SimpleNoteEditor
        show={show}
        onClose={handleClose}
        objectId={props.objectId}
        objectType={props.objectType}
        additionalText={props.additionalText}
        onlyOneByObjectType={false}
      />
    </>
  );
};
